<template>
  <ControlWrapper
    v-bind="control.controlWrapper.value"
    :styles="control.styles"
    :is-focused="control.isFocused.value"
    :applied-options="control.appliedOptions.value"
    :error="control.control.value.errors"
  >
    <div class="widget-base-radio-group">
      <label :class="[control.styles.control.label, '!mb-3 inline-block']">{{ control.computedLabel.value }}</label>
      <p class="widget-base-radio-group_description">{{ control.control.value.description }}</p>
      <fieldset class="my-6">
        <legend class="sr-only">{{ control.computedLabel.value }}</legend>
        <div
          :class="[
            twMerge('widget-base-radio-group_wrapper', control.styles.control.input),
            componentStyles?.radioGroup,
          ]"
          :disabled="!control.control.value.enabled"
          :autofocus="control.appliedOptions.value.focus"
          :placeholder="control.appliedOptions.value.placeholder"
          :hint="control.control.value.description"
          :persistent-hint="persistentHint()"
          :required="control.control.value.required"
        >
          <div
            v-for="option in control.control.value.schema.properties?.time.oneOf"
            :key="option.const"
            class="widget-base-radio-group_input-wrapper"
            @click="setSelectedOption(option.const)"
          >
            <WInput
              :disabled="!control.control.value.enabled"
              :id="String(option.const)"
              :name="control.computedLabel.value.toLowerCase().replaceAll(' ', '-')"
              type="radio"
              :checked="option.const === selectedOption"
              class="widget-base-radio-group_input"
              :data-selected="option.const === selectedOption"
              @input="setSelectedOption(option.const)"
            />
            <label :for="option.const" class="widget-base-radio-group_label">{{ option.title }}</label>
          </div>
        </div>
      </fieldset>
      <WTextarea
        v-model="note"
        name="note"
        :disabled="!control.control.value.enabled"
        :label="noteOptions.title || 'Notes'"
        subtitle
        @update:model-value="setNote"
      />
      <p class="body1-bold text-negative-500">{{ control.control.value.errors }}</p>
    </div>
  </ControlWrapper>
</template>

<script setup lang="ts">
  import { ControlElement } from '@jsonforms/core';
  import { nextTick, ref } from 'vue';
  import { twMerge } from 'tailwind-merge';
  import { rendererProps, useJsonFormsEnumControl } from '@jsonforms/vue';
  import { default as ControlWrapper } from './ControlWrapper.vue';
  import { useWidgetControl } from '../util';
  import WInput from '../../base/Input.vue';
  import WTextarea from '../../base/Textarea.vue';
  import { checkTheme, getComponentStyle } from 'src/utils/config';

  type NoteOptions = {
    title: string;
  };

  const props = defineProps(rendererProps<ControlElement>());
  const control = useWidgetControl(useJsonFormsEnumControl(props));
  const componentStyles = getComponentStyle();
  const noteOptions = ref(control.control.value.schema?.properties?.note as NoteOptions);
  const defaultValue = {
    time: (control.control.value.schema?.properties?.time.oneOf?.[0]?.const as string) || '',
    note: '',
  };
  const controlValue = ref(
    control.control.value.data ? (control.control.value.data as typeof defaultValue) : defaultValue
  );
  const selectedOption = ref(controlValue.value.time);
  const note = ref(controlValue.value.note);

  function setSelectedOption(val: string) {
    selectedOption.value = val;
    control.onChange({ time: val, note: note.value });
  }

  function setNote() {
    nextTick(() => {
      control.onChange({ time: selectedOption.value, note: note.value });
    });
  }

  function persistentHint() {
    return checkTheme('volkswagen', 'bentley', 'vwg');
  }
</script>
